import React from 'react';
import './VenueAnalysisGrid.scss';
import './OrderLiquidityBreakdown.scss';

import {
    isVenueSelected,
    VenueSelected,
} from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';

import './VenueAnalysisTypeToVenueSankey.scss';
import { getVenueTypeToVenueSankeyData } from 'widgets/venueAnalysis/grid/VenueAnalysisGridSankeyData';
import { VenueAnalysisVenueDisplayData } from 'widgets/venueAnalysis/grid/gridData';
import classNames from 'classnames';
import { VenueAnalysisSankey } from 'widgets/venueAnalysis/grid/VenueAnalysisSankey';

interface VenueAnalysisTypeToVenueSankeyProps {
    className?: string;
    data: VenueAnalysisVenueDisplayData;
    selection: VenueSelected;
    width: number;
}

export function VenueAnalysisTypeToVenueSankey({
    data,
    selection,
    width: containerWidth,
    className,
}: VenueAnalysisTypeToVenueSankeyProps) {
    if (!isVenueSelected(selection)) {
        return <></>;
    }

    const getData = (width: number) =>
        getVenueTypeToVenueSankeyData(width, data, selection, className ?? '');

    const classes = classNames('VenueAnalysisTypeToVenueSankey', className);

    return (
        <div className={classes}>
            <VenueAnalysisSankey
                width={containerWidth}
                height={30}
                getData={getData}
            />
        </div>
    );
}
